import Vue from 'vue'
import Vuex from 'vuex'

import functions from './modules/functions'
import namespaces from './modules/namespace'
import packages from './modules/packages'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    functions,
    namespaces,
    packages
  }
})
